/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { get } from 'utils/lodash'

import { VIEW_MODE_SEQUENCE, VIEW_MODE_BOARD_V2, VIEW_MODE_LIST } from './routeSlice'

// Per-browser default landing view for Route Manager (Board / Advanced Board / List).
// Map and Advanced Map are intentionally excluded from the allowed set.
export const ROUTE_VIEW_PREF_MODES = [VIEW_MODE_SEQUENCE, VIEW_MODE_BOARD_V2, VIEW_MODE_LIST] as const

export type RouteViewPrefMode = typeof ROUTE_VIEW_PREF_MODES[number]

export type PersistentRouteViewPrefState = {
  defaultView: RouteViewPrefMode | null
}

const initialState: PersistentRouteViewPrefState = {
  defaultView: null,
}

const persistentRouteViewPrefSlice = createSlice({
  name: 'persistentRouteViewPref',
  initialState: { ...initialState },
  reducers: {
    setDefaultRouteView: (state, action: PayloadAction<RouteViewPrefMode>) => {
      state.defaultView = action.payload
    },
    clearDefaultRouteView: state => {
      state.defaultView = null
    },
  },
})

export const { setDefaultRouteView, clearDefaultRouteView } = persistentRouteViewPrefSlice.actions

export const selectDefaultRouteView = (state: unknown): RouteViewPrefMode | null => {
  const storedView = get(state, 'persistentRouteViewPref.defaultView') as RouteViewPrefMode | null
  return ROUTE_VIEW_PREF_MODES.includes(storedView as RouteViewPrefMode) ? storedView : null
}

export default persistentRouteViewPrefSlice.reducer
